import {rpFeatureFlagVoxReservation} from "../../app/read_rp_environment_variables";
import {getOfferDisplayStatus} from "../../offer/utils/get_offer_display_status";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {PropertyDisplayType} from "../../property/types/PropertyDisplayType";

// SSR-safe part of the gate - availability is checked on the client on top of it.
// "limited" also covers unavailable and archived offers.
export const isPropertyReservationEligible = (property: IPropertyDetail | null): property is IPropertyDetail =>
    rpFeatureFlagVoxReservation &&
    !!property &&
    property.offer.configuration.is_online_reservation_enabled === true &&
    property.for_sale &&
    property.configuration.display_type === PropertyDisplayType.PUBLISHED &&
    getOfferDisplayStatus(property.offer) !== "limited";
import {rpFeatureFlagVoxReservation} from "../../app/read_rp_environment_variables";
import {getOfferDisplayStatus} from "../../offer/utils/get_offer_display_status";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";
import {PropertyDisplayType} from "../../property/types/PropertyDisplayType";

// SSR-safe part of the gate - availability is checked on the client on top of it.
// "limited" also covers unavailable and archived offers.
export const isPropertyReservationEligible = (property: IPropertyDetail | null): property is IPropertyDetail =>
    rpFeatureFlagVoxReservation &&
    !!property &&
    property.offer.configuration.is_online_reservation_enabled === true &&
    property.for_sale &&
    property.configuration.display_type === PropertyDisplayType.PUBLISHED &&
    getOfferDisplayStatus(property.offer) !== "limited";
